<template>
  <div class="discount-tip" v-if="true || paymentStore.showDiscountTip">
    <!-- <p class="mb-[8px]">
      套餐生效中，续约后权益将于 2025.01.17 生效，如果言币不够用，可以进行<Button
        variant="text-warning"
        size="mini"
        class="!text-[var(--x-warning-9)]"
        @click="emit('add-coin')"
        >言币加购</Button
      >
    </p> -->
    <p>连续包月套餐，仅在活动期间享受88折价格，活动后恢复原价</p>
  </div>
</template>
<script setup lang="ts" name="DiscountTip">
// import { Button } from '@rendora/design/components/button/index';
import { usePayment } from '../store';

const paymentStore = usePayment();

const emit = defineEmits(['add-coin']);
</script>
<style lang="scss">
.discount-tip {
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: var(--x-text-3);
  // p {
  //   margin-bottom: 0;
  // }
}
</style>
